var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "v-new-room-inner" },
    [
      _c(
        "div",
        { staticClass: "room-settings-group" },
        [
          _c("div", { staticClass: "setting-item" }, [
            _c("span", { staticClass: "common-title" }, [_vm._v("房间人数")]),
            _c(
              "div",
              { staticClass: "common-list" },
              [
                _vm.isTeamMode == 1
                  ? [
                      _c(
                        "span",
                        {
                          staticClass:
                            "common-list-item active text-center-lock",
                          staticStyle: { flex: "1", cursor: "not-allowed" },
                        },
                        [_vm._v("4人 (2v2)")]
                      ),
                    ]
                  : [
                      _c(
                        "span",
                        {
                          class: [
                            "common-list-item",
                            _vm.joinCount == 2 ? "active" : "",
                          ],
                          on: {
                            click: function ($event) {
                              return _vm.handleChangeJoinCount(2)
                            },
                          },
                        },
                        [_vm._v("2人")]
                      ),
                      _c(
                        "span",
                        {
                          class: [
                            "common-list-item",
                            _vm.joinCount == 3 ? "active" : "",
                          ],
                          on: {
                            click: function ($event) {
                              return _vm.handleChangeJoinCount(3)
                            },
                          },
                        },
                        [_vm._v("3人")]
                      ),
                    ],
              ],
              2
            ),
          ]),
          _c("div", { staticClass: "setting-item" }, [
            _c("span", { staticClass: "common-title" }, [_vm._v("对战模式")]),
            _c("div", { staticClass: "common-list" }, [
              _c(
                "span",
                {
                  class: [
                    "common-list-item",
                    "mode-item",
                    _vm.isTeamMode == 0 ? "active" : "",
                  ],
                  on: {
                    click: function ($event) {
                      return _vm.handleSwitchTeamMode(0)
                    },
                  },
                },
                [_vm._v("个人赛")]
              ),
              _c(
                "span",
                {
                  class: [
                    "common-list-item",
                    "mode-item",
                    _vm.isTeamMode == 1 ? "active" : "",
                  ],
                  on: {
                    click: function ($event) {
                      return _vm.handleSwitchTeamMode(1)
                    },
                  },
                },
                [_vm._v("团队赛")]
              ),
            ]),
          ]),
          _c("div", { staticClass: "setting-item" }, [
            _c("span", { staticClass: "common-title" }, [_vm._v("游戏机制")]),
            _c("div", { staticClass: "common-list" }, [
              _c(
                "span",
                {
                  class: [
                    "common-list-item",
                    "mode-item",
                    _vm.isCrazyMode == 0 ? "active" : "",
                  ],
                  on: {
                    click: function ($event) {
                      _vm.isCrazyMode = 0
                    },
                  },
                },
                [_vm._v("普通模式")]
              ),
              _c(
                "span",
                {
                  class: [
                    "common-list-item",
                    "mode-item",
                    _vm.isCrazyMode == 1 ? "active" : "",
                  ],
                  on: {
                    click: function ($event) {
                      _vm.isCrazyMode = 1
                    },
                  },
                },
                [_vm._v("疯狂模式")]
              ),
            ]),
          ]),
          _c("transition", { attrs: { name: "fade" } }, [
            _vm.isCrazyMode == 1
              ? _c("div", { staticClass: "crazy-rule-tip" }, [
                  _c("i", { staticClass: "tip-icon" }, [_vm._v("!")]),
                  _c("div", { staticClass: "tip-content" }, [
                    _c("span", { staticClass: "tip-title" }, [
                      _vm._v("疯狂模式规则："),
                    ]),
                    _c("p", { staticClass: "tip-desc" }, [
                      _vm._v(
                        "在该模式下规则颠倒，对战结束后**箱子开出总价值最低（最小）的玩家获得胜利**！"
                      ),
                    ]),
                  ]),
                ])
              : _vm._e(),
          ]),
        ],
        1
      ),
      _c("div", { staticClass: "filter-tool-bar" }, [
        _c("div", { staticClass: "case_catgory_container_wrapper" }, [
          _c(
            "div",
            { staticClass: "case_catgory_container" },
            _vm._l(
              _vm.cases_types,
              function (cases_category, cases_category_index) {
                return _c(
                  "div",
                  {
                    key: cases_category_index,
                    staticClass: "case_catgory",
                    class: { active: _vm.current_case_title == cases_category },
                    on: {
                      click: function ($event) {
                        _vm.current_case_title = cases_category
                      },
                    },
                  },
                  [_vm._v(" " + _vm._s(cases_category) + " ")]
                )
              }
            ),
            0
          ),
        ]),
        _c("div", { staticClass: "room-price-order" }, [
          _c("div", { staticClass: "common-list" }, [
            _c(
              "span",
              {
                class: [
                  "common-list-item",
                  "list-order-btn",
                  _vm.toggleCasePriceSortFlag ? "active" : "",
                ],
                on: { click: _vm.toggleCasePriceOrder },
              },
              [
                _vm._v(
                  " 价格 " +
                    _vm._s(_vm.toggleCasePriceSortFlag ? "↓" : "↑") +
                    " "
                ),
              ]
            ),
          ]),
        ]),
      ]),
      _c("div", { staticClass: "case-con st_scroll_d" }, [
        _c(
          "ul",
          { staticClass: "case-list" },
          _vm._l(_vm.filteredCaseData, function (item) {
            return _c("li", { key: item.id }, [
              _c(
                "div",
                {
                  staticClass: "list-item",
                  class: { active: _vm.getMatchCountInQueue(item.id) > 0 },
                  on: {
                    click: function ($event) {
                      return _vm.handleSelectBox(item)
                    },
                  },
                },
                [
                  _c("button", {
                    staticClass: "questionMarkBtn",
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        return _vm.openCaseDetailModal(item)
                      },
                    },
                  }),
                  _c("div", { staticClass: "img-wrapper" }, [
                    _c("img", {
                      staticClass: "case-bg-img",
                      attrs: { src: _vm._f("imgfilter")(item.casePic) },
                    }),
                    item.itemPic
                      ? _c("img", {
                          staticClass: "itempic",
                          attrs: { src: _vm._f("imgfilter")(item.itemPic) },
                        })
                      : _vm._e(),
                  ]),
                  _c("div", { staticClass: "item-meta" }, [
                    _c("div", { staticClass: "case-name" }, [
                      _vm._v(_vm._s(item.caseName)),
                    ]),
                    _c("div", { staticClass: "case-price" }, [
                      _vm._v(_vm._s(item.casePrice)),
                    ]),
                  ]),
                  _vm.getMatchCountInQueue(item.id) > 0
                    ? _c("div", { staticClass: "badge-count" }, [
                        _vm._v(
                          " " + _vm._s(_vm.getMatchCountInQueue(item.id)) + " "
                        ),
                      ])
                    : _vm._e(),
                ]
              ),
            ])
          }),
          0
        ),
      ]),
      _c("div", { staticClass: "selected-sequence-wrapper" }, [
        _c("div", { staticClass: "sequence-title" }, [
          _vm._v(" 已选箱子序列 "),
          _c("span", [_vm._v("(" + _vm._s(_vm.totalSelectedCount) + "/99)")]),
        ]),
        _c(
          "div",
          { staticClass: "sequence-container st_scroll_d" },
          [
            _c(
              "transition-group",
              {
                staticClass: "sequence-inner",
                attrs: { name: "list", tag: "div" },
              },
              _vm._l(_vm.selectedBoxQueue, function (box, index) {
                return _c(
                  "div",
                  {
                    key: box.queueId,
                    staticClass: "sequence-item",
                    attrs: { title: "点击移除" },
                    on: {
                      click: function ($event) {
                        return _vm.handleCancelSelectByIndex(index)
                      },
                    },
                  },
                  [
                    _c("div", { staticClass: "seq-index" }, [
                      _vm._v(_vm._s(index + 1)),
                    ]),
                    _c("img", {
                      staticClass: "seq-img",
                      attrs: { src: _vm._f("imgfilter")(box.casePic) },
                    }),
                    _c("div", { staticClass: "seq-price" }, [
                      _vm._v("$" + _vm._s(box.casePrice)),
                    ]),
                    _c("div", { staticClass: "seq-mask-remove" }, [
                      _vm._v("移除"),
                    ]),
                  ]
                )
              }),
              0
            ),
            _vm.selectedBoxQueue.length === 0
              ? _c("div", { staticClass: "sequence-empty" }, [
                  _vm._v(" 请从上方列表中点击选择盲盒 (最多10个) "),
                ])
              : _vm._e(),
          ],
          1
        ),
      ]),
      _c("div", { staticClass: "sn-input-box" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.roomPassword,
              expression: "roomPassword",
            },
          ],
          staticClass: "sign-up__field__input",
          attrs: { placeholder: "房间密码(选填，留空则公开)", type: "text" },
          domProps: { value: _vm.roomPassword },
          on: {
            input: function ($event) {
              if ($event.target.composing) {
                return
              }
              _vm.roomPassword = $event.target.value
            },
          },
        }),
      ]),
      _c("div", { staticClass: "action-btn-group" }, [
        _c(
          "div",
          {
            staticClass: "new-button main-create-btn",
            class: { disable: _vm.loading },
            on: { click: _vm.handleNewRoom },
          },
          [
            _vm._v(" 立即创建 "),
            _c("span", [
              _vm._v(_vm._s(_vm._f("conversion")(_vm.totalSelectedPrice))),
            ]),
            _vm._v(" "),
            _vm.isHappyCoin
              ? _c("span", { staticClass: "coin-unit" }, [_vm._v("欢乐豆")])
              : _vm._e(),
          ]
        ),
        _c("div", { staticClass: "sub-btn-row" }, [
          _c(
            "div",
            {
              staticClass: "new-button reset-button",
              class: { disable: _vm.loading },
              on: { click: _vm.handleReset },
            },
            [_vm._v("清除选择")]
          ),
          _c(
            "div",
            {
              staticClass: "new-button last-button",
              class: { disable: _vm.loading },
              on: { click: _vm.lastCreateFunc },
            },
            [_vm._v("上次选项")]
          ),
        ]),
      ]),
      _c(
        "Drawer",
        {
          attrs: {
            "class-name": "app-drawer",
            transfer: false,
            placement: "bottom",
            height: "350",
          },
          model: {
            value: _vm.case_detail_modal.flag,
            callback: function ($$v) {
              _vm.$set(_vm.case_detail_modal, "flag", $$v)
            },
            expression: "case_detail_modal.flag",
          },
        },
        [
          _c("c-battleCaseDetail", {
            attrs: { caseInfo: _vm.case_detail_modal.caseInfo },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }